import React from 'react'
import { Helmet } from 'react-helmet-async'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import { useNavigate, useParams } from 'react-router-dom'

import AppButton from '../partials/Navigation/AppButton'
import { CapitalButton } from '../partials/Navigation/Buttons'
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import { TextInput } from '../partials/Inputs/Inputs'
import withAppStore from '../../util/withAppStore'

import styles from '../../../css/home.module.css'
import stylesSettings from '../../../css/settings.module.css'

import AppStore from '../../stores/AppStore'
import AppDispatcher from '../../dispatchers/AppDispatcher'

function CustomerDeviceGroupAddPage (props) {
  const navigate = useNavigate()
  const { customerID } = useParams()

  const [state, setState] = React.useState({
    name: '',
    icon: undefined,
    isValid: false,
  })

  const goTo = React.useCallback((x) => navigate(x), [navigate])

  const goBack = React.useCallback(() => {
    const { id: customerIDFromStore } = AppStore.getCustomer()
    goTo(`/${customerIDFromStore}/settings/deviceGroups`)
  }, [goTo])

  const childChange = React.useCallback((event) => {
    const {
      target: { name: field, value },
    } = event

    handleChange(field, value)
  }, [])

  const handleApiResponse = React.useCallback((error) => {
    const newState = {
      statusMessageIsVisible: true,
      saved: !!error,
    }
    setState(prevState => ({ ...prevState, ...newState }))
  }, [])

  const handleChange = React.useCallback((field, value, callback) => {
    setState(prevState => {
      const newState = {
        ...prevState,
        [field]: value,
      }

      const { icon, name } = newState

      const notEmpty = (value) => typeof value === 'string' && value.length > 0

      newState.isValid = notEmpty(name) && notEmpty(icon)

      return newState
    })

    if (callback) callback()
  }, [])

  const saveGroup = React.useCallback(() => {
    const { name, icon } = state

    const group = {
      customer_id: customerID,
      name,
      device_group: `${name}`,
      icon,
    }

    AppDispatcher.dispatch({
      action: 'set-group',
      group,
      update: false,
      callback: () => goBack(),
    })
  }, [state, customerID, goBack])

  React.useEffect(() => {
    AppStore.addChangeListener(handleChange)

    return () => {
      AppStore.removeChangeListener(handleChange)
    }
  }, [handleChange])

  const {
    auth: { logout },
    intl: { formatMessage },
    pages: { CustomerDeviceGroupAddPage: title },
    route: { path },
  } = props

  const { icon, isValid, name } = state

  const icons = {
    // AddNew: 'AddNew',
    Bin: 'Bin',
    ColdAirDrain: 'ColdAirDrain',
    Flow: 'Flow',
    // Level: 'Level',
    MoistureSensor: 'Moisture',
    // Power: 'Power',
    Pump: 'Pump',
    PumpFrostWater: 'PumpFrostWater',
    // Speedometer: 'Speedometer',
    // RedX: 'RedX',
    Thermometer: 'Thermometer',
    // Tractor: 'Tractor',
    Valve: 'Valve',
    Weather: 'Weather',
    WindMachine: 'WindMachine',
  }

  const iconButtons = Object.keys(icons)
    .sort((a, b) => a.localeCompare(b))
    .map((key) => {
      return (
        <AppButton
          application={key}
          checked={icon === key}
          icon={key}
          label=''
          key={key}
          onClick={() => handleChange('icon', icons[key])}
        />
      )
    })

  let saveButton

  if (isValid) {
    saveButton = (
      <CapitalButton
        text={formatMessage({
          id: 'setting.save',
          defaultMessage: 'SAVE',
          description: 'SAVE button',
        })}
        buttonFunction={saveGroup}
        hSize='h2'
        style={styles.saveButton}
      />
    )
  }

  return (
    <div>
      <Helmet><title>{title}</title></Helmet>
      <NavigationBar
        page={path}
        logOut={() => logout(navigate)}
        backFunc={goBack}
        name={title}
      />
      <div className={styles.pageWidth}>
        <div className={styles.pageContainer}>
          <section className={`${stylesSettings.inputArea}`}>
            <FormattedMessage
              id='general.group.name'
              defaultMessage='Group Name'
              description='Group Name label'
              tagName='h5'
            />
            <div className={stylesSettings.groupName}>
              <TextInput
                value={name}
                field='name'
                childChange={childChange}
                style={stylesSettings.groupNameInput}
              />
            </div>
          </section>
          <section
            className={stylesSettings.inputArea}
            style={{ display: 'inline-block' }}
          >
            <div style={{ marginBottom: '1em' }}>
              <FormattedMessage
                id='customer.settings.choose.icon'
                defaultMessage='Please Choose an Icon for the Group'
                tagName='h5'
              />
            </div>
          </section>
          <div className={styles.list}>{iconButtons}</div>
          <section>
            {saveButton}
          </section>
        </div>
      </div>
      <Footer />
    </div>

  )
}

CustomerDeviceGroupAddPage.propTypes = {
  pages: PropTypes.object,
  data: PropTypes.object,
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
}

export default withAppStore(injectIntl(CustomerDeviceGroupAddPage))
